import React, {useContext} from 'react'
import {useFormContext} from "react-hook-form";
import {labelSizeClass} from "./labelSize";

export default function UiInputList({ label, name, size, labelSize, idField, titleField, list, valueAsNumber, placeholder, ...rest }: any){
    const { register, watch } = useFormContext();
    const currentValue = watch(name);

    return (
        <div className={`col-lg-${(size) ? size : 12}`}>
            <div className={`form-item${labelSizeClass(labelSize)}`}>
                <label className="form-label">{label}</label>
                <div className="field-container">
                    <select className="form-control" {...register(name, { valueAsNumber: valueAsNumber || false })} {...rest}>
                        {placeholder !== false && <option value="">{placeholder || 'Selecione...'}</option>}
                        { list && list.map((item: any, index: any) => <option key={index} value={item[idField]}>{item[titleField]}</option> )}
                    </select>
                </div>
            </div>
        </div>
    )
}